export const SMALL_TYPE_TIMER = 'small'
export const LARGE_TYPE_TIMER = 'large'
export const DEFAULT_TYPE_TIMER = 'default'
export const ONE_SECOND = 1000
